import { BAR_CHART, COLUMN_CHART, LINE_CHART, STACKED_CHART } from '../../../utils/dashboardConsts';

export const LEFT = 'left';
export const RIGHT = 'right';
export const DEFAULT_FORMAT_TYPE = 'number';

export const SIDE_AXIS_CHART_TYPES = [LINE_CHART, COLUMN_CHART, BAR_CHART];
export const RANGE_AXIS_CHART_TYPES = [LINE_CHART, COLUMN_CHART, BAR_CHART, STACKED_CHART];

export const isSideAxisChart = chartTypeName => SIDE_AXIS_CHART_TYPES.includes(chartTypeName);
export const isRangeAxisChart = chartTypeName => RANGE_AXIS_CHART_TYPES.includes(chartTypeName);

export const metricFormatType = metric => (metric.displayFormat && metric.displayFormat.type) || DEFAULT_FORMAT_TYPE;

// Default side per metric, mirroring getGroupedYAxis: group metrics by format type
// (first-seen order); each type's side alternates by its group index (even => left,
// odd => right). Returns { [metricName]: 'left' | 'right' }.
export const getDefaultSides = (metrics = []) => {
    const order = [];
    const seenTypes = new Set();
    metrics.forEach(metric => {
        const type = metricFormatType(metric);
        if (!seenTypes.has(type)) {
            seenTypes.add(type);
            order.push(type);
        }
    });
    const sideOfType = new Map(order.map((type, index) => [type, index % 2 === 0 ? LEFT : RIGHT]));
    const sides = {};
    metrics.forEach(metric => {
        sides[metric.name] = sideOfType.get(metricFormatType(metric));
    });
    return sides;
};

// Saved side overrides are keyed by the config metric name (e.g. cohort/period
// metrics use double underscores: `total_revenue__actual`), but at render the
// metric name comes from the report result, where it may be single-underscored
// (`total_revenue_actual`). Collapse `__`→`_` on both sides so they match.
const canonicalMetricName = name => (name || '').replace(/__/g, '_');

// Effective side per metric = a valid saved override, else the computed default.
export const resolveSides = (savedSides, metrics = []) => {
    const defaults = getDefaultSides(metrics);
    const overridesByCanonical = {};
    if (savedSides) {
        Object.keys(savedSides).forEach(key => {
            overridesByCanonical[canonicalMetricName(key)] = savedSides[key];
        });
    }
    const sides = {};
    metrics.forEach(metric => {
        const override = overridesByCanonical[canonicalMetricName(metric.name)];
        sides[metric.name] = override === LEFT || override === RIGHT ? override : defaults[metric.name];
    });
    return sides;
};
